import styled, { keyframes } from 'styled-components';
import {
    BACKGROUND_DEEP,
    CONTENT_DISABLED,
    PRIMARY_HOVER,
} from '@amzn/ring-common-style-library/lib/colors';
import { BODY_SMALL_LIGHT } from '@amzn/ring-common-style-library/lib/typography';

import { GlowConfig } from '../../utils/animationUtils';

export const createConfigurableGlow = (glowConfig: GlowConfig) => {
    // Generate keyframe steps
    const keyframeSteps = Object.entries(glowConfig).map(([percentage, intensity]) => {
        if (intensity === 0) {
            return `${percentage} { text-shadow: none; }`;
        }
        
        return `${percentage} {
            text-shadow: 
                0 0 ${1 * intensity}px ${BACKGROUND_DEEP},
                0 0 ${4 * intensity}px ${PRIMARY_HOVER};
            color: ${intensity > 0.5 ? PRIMARY_HOVER : CONTENT_DISABLED};
            color: color-mix(in srgb, ${PRIMARY_HOVER} ${intensity * 100}%, ${CONTENT_DISABLED});
        }`;
    }).join('\n');

    return keyframes`
        ${keyframeSteps}
    `;
};

const AnimatedContainer = styled.div`
    display: inline-flex;
    align-items: center;
    max-width: fit-content;
    color: ${CONTENT_DISABLED};
`;

const ReasoningTextContainer = styled.span`
    display: inline-flex;
    font-style: italic;
    letter-spacing: 0.01em;
    user-select: none;
    ${BODY_SMALL_LIGHT};
`;

// CONFIGURABLE GLOW VARIANTS
const AnimatedLetterConfigurable = styled.span<{ glowConfig: GlowConfig }>`
    color: ${CONTENT_DISABLED};
    animation: ${props => createConfigurableGlow(props.glowConfig)} 4s infinite linear;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
        color: ${CONTENT_DISABLED};
        text-shadow: none;
    }
`;

export default {
    AnimatedContainer,
    ReasoningTextContainer,
    AnimatedLetterConfigurable,
};

